// This is just a wrapper for Plyr with placetel specific options
import Plyr from 'plyr';

const VideoPlayer = (element) => new Plyr(element, {
  iconUrl: window.location.origin + '/assets/dist/placetel/images/plyr.io.svg',
  blankVideo: window.location.origin + '/assets/dist/placetel/videos/blank.mp4',
});

export { VideoPlayer };